<template>
    <div v-if="suggFlightLs && suggFlightLs.length!=0" class="card info-flight w-100">
        
        <label :class="suggFlightLs.type=='Cheapest'?'cheapest-tag'
                                              :suggFlightLs.type=='Best' ? 'best-tag': 'quickest-tag'">
            <div class="wrapper">
                {{suggFlightLs.type=='Cheapest'?$t("flightResults.cheapest")
                :suggFlightLs.type=='Best' ?
                $t("flightResults.best"): $t("flightResults.quickest")}}
            </div>
        </label>
        <div class="main-info-wrap" :class="suggFlightLs.pUnit.length==1?'':'divider'">
            <div v-for="(pUnit,pindex) in suggFlightLs.pUnit"
                 :key="'punit'+pindex" class="info-wrap"
            >
                <div class="flight-name">
                    <div v-if="pUnit.obFlight" class="logo">
                        <!-- <img :src="$options.filters.ALimage(pUnit.obFlight && pUnit.obFlight[0].flight.opAirline)"
                             :onerror="defaultALImg"> -->
                             <img v-if="GET_AIRLINES"
                                :src="GET_AIRLINES[pUnit.obFlight && pUnit.obFlight[0].flight.opAirline].logourl||defaultALImg"
                        />
                    </div>
                    <div v-if="pUnit.ibFlight" class="logo">
                        <img v-if="GET_AIRLINES"
                                :src="GET_AIRLINES[pUnit.ibFlight && pUnit.ibFlight[0].flight.opAirline].logourl||defaultALImg"
                        />
                        <!-- <img :src="$options.filters.ALimage(pUnit.ibFlight && pUnit.ibFlight[0].flight.opAirline)"
                             :onerror="defaultALImg"> -->
                    </div>
                    <div class="name">
                        <div v-if="pUnit.obFlight" class="t-flight-name">
                            <div>{{
                                pUnit.obFlight[0].flight.opAirline|airlineName }}
                            </div>
                        </div>
                        <div v-else class="t-flight-name"> {{pUnit.ibFlight[0].flight.opAirline|airlineName }}
                        </div>
                        <div class="d-flex flex-flow-column">
                                                  <span v-if="pUnit.obFlight" class="flight-code">
                                                     
                                                  {{pUnit.obFlight[0].flight.FlightNo}}
                                                  </span>
                            <span v-else class="flight-code">
                                                  
                                                  {{pUnit.ibFlight[0].flight.FlightNo}}
                                                  </span>
                            <span v-if="pUnit.obFlight" class="flight-code">
                                                    {{pUnit.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}
                                                  </span>
                            <span v-else class="flight-code">
                                                    {{pUnit.ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DAY_DATE_MONTH)}}
                                                  </span>
                        </div>
                    </div>
                </div>
                <div class="time-place-wrap">
                    <div class="left">
                        <div v-if="pUnit.obFlight" class="time" v-c-tooltip.hover="{
                                                content:`${dateFormatInTooltip(pUnit.obFlight && pUnit.obFlight[0].flight.DepDate)}
                                                 `,}">
                            {{pUnit.obFlight && pUnit.obFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                        </div>
                        <div v-else class="time" v-c-tooltip.hover="{
                                                          content:`${dateFormatInTooltip(pUnit.ibFlight && pUnit.ibFlight[0].flight.DepDate)}
                                                            `,}">
                            {{pUnit.ibFlight && pUnit.ibFlight[0].flight.DepDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                        </div>
                        <div v-if="pUnit.obFlight" class="place-code">
                            {{pUnit.obFlight[0].flight.DepAirport}}
                        </div>

                        <div v-else class="place-code">
                            {{pUnit.ibFlight[0].flight.DepAirport}}
                        </div>
                        <div v-if="pUnit.obFlight" class="place mr--2px">
                            {{pUnit.obFlight[0].flight.DepAirport | cityName}}
                        </div>
                        <div v-else class="place mr--2px">
                            {{pUnit.ibFlight[0].flight.DepAirport | cityName}}
                        </div>
                    </div>
                    <div class="center">
                                              <span v-if="pUnit.obFlight">
                                                {{pUnit.obFlight[0].flight.TotalDuration|convertToHrMin("minutes","H [h] mm [m]")}}
                                              </span>
                        <span v-else>
                                                {{pUnit.ibFlight[0].flight.TotalDuration|convertToHrMin("minutes","H [h] mm [m]")}}
                                              </span>
                       
                        <svg xmlns="http://www.w3.org/2000/svg"
                             xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Capa_1" x="0px" y="0px"
                             width="510px" height="510px" viewBox="0 0 510 510" xml:space="preserve"><g><g id="flights"><path d="M510,255c0-20.4-17.85-38.25-38.25-38.25H331.5L204,12.75h-51l63.75,204H76.5l-38.25-51H0L25.5,255L0,344.25h38.25    l38.25-51h140.25l-63.75,204h51l127.5-204h140.25C492.15,293.25,510,275.4,510,255z"></path></g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g>
                            <g></g></svg>
                        <span v-if="pUnit.obFlight && isStopsForNonMyanmar">
                                              {{pUnit.obFlight[0].flight.no_of_stops && pUnit.obFlight[0].flight.no_of_stops.name}}
                                            </span>
                        <span v-else-if="pUnit.ibFlight && isStopsForNonMyanmar">
                                              {{pUnit.ibFlight[0].flight.no_of_stops && pUnit.ibFlight[0].flight.no_of_stops.name}}
                                            </span>
                        <span v-if="pUnit.obFlight">
                                                                                                        {{pUnit.obFlight[0].flight.Via_Obj}}
                                                                                                     </span>
                        <span v-else>
                                                                                                       {{pUnit.ibFlight[0].flight.Via_Obj}}
                                                                                                     </span>
                    </div>
                    <div class="right">
                        <div v-if="pUnit.obFlight" class="time" v-c-tooltip.hover="{
                                                                  content:`${dateFormatInTooltip(pUnit.obFlight &&pUnit.obFlight[pUnit.obFlight.length-1].flight.ArrDate)}
                                                                  `,}">
                            {{pUnit.obFlight &&pUnit.obFlight[pUnit.obFlight.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                        </div>
                        <div v-else class="time" v-c-tooltip.hover="{
                                                                  content:`${dateFormatInTooltip(pUnit.ibFlight &&pUnit.ibFlight[pUnit.ibFlight.length-1].flight.ArrDate)}
                                                                  `,}">
                            {{pUnit.ibFlight &&pUnit.ibFlight[pUnit.ibFlight.length-1].flight.ArrDate|formatDate(DATE_TIME_FORMAT.DEFAULT_TIME_FORMAT)}}
                        </div>
                        <span v-if="pUnit.obFlight" class="day" v-c-tooltip.hover="{
                                                      content:`${noOfDaysTooltip(pUnit.obFlight[0].flight.no_of_days)}`,}">
                                                      {{pUnit.obFlight[0].flight.no_of_days}}
                                                </span>
                        <span v-else class="day" v-c-tooltip.hover="{
                                                      content:`${noOfDaysTooltip(pUnit.ibFlight && pUnit.ibFlight[0].flight.no_of_days)}`,}">
                                                      {{pUnit.ibFlight && pUnit.ibFlight[0].flight.no_of_days}}
                                                </span>
                        <div v-if="pUnit.obFlight" class="place-code">
                            {{pUnit.obFlight[
                            pUnit.obFlight.length-1].flight.ArrAirport}}
                        </div>
                        <div v-else class="place-code">
                            {{pUnit.ibFlight[
                            pUnit.ibFlight.length-1].flight.ArrAirport}}
                        </div>
                        <div v-if="pUnit.obFlight" class="place ml--2px">
                            {{pUnit.obFlight[pUnit.obFlight.length-1].flight.ArrAirport
                            | cityName}}
                        </div>
                        <div v-else class="place ml--2px">
                            {{pUnit.ibFlight[pUnit.ibFlight.length-1].flight.ArrAirport
                            | cityName}}
                        </div>
                    </div>
                </div>
                <div class="luggage d-flex">
                    
                    <span v-if="pUnit.obFlight && pUnit.obFlight[0].flight.baggage">
                        <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt="">
                                              {{pUnit.obFlight[0].flight.baggage[0].weightinkg+' Kg'}}
                                            </span>
                    <span v-else-if="pUnit.ibFlight && pUnit.ibFlight[0].flight.baggage">
                                             <img src="@imgPath/img/svg/icons/Suitcase_icon.svg" alt="">
                                              {{pUnit.ibFlight[0].flight.baggage[0].weightinkg+' Kg'}}
                                            </span>
                </div>
            </div>
        </div>
        <div class="price-details-wrap">
            <div class="price-details">
                <div class="pd-div">
                    <div class="price">
                        <span>{{suggFlightLs.clientPricing.Currency}}</span>
                        {{suggFlightLs.clientPricing.AdultPrice.Total | amountformat}}
                    </div>
                    <div class="pass-count">
                       {{$t("flightResults.cMLSuggFlightResCard.pricePerPassenger")}}
                    </div>
                </div>
                <div  @click="$emit('onBooking',suggFlightLs.pUnit)"
                     class="book-btn">
                    {{$t("flightResults.cMLSuggFlightResCard.book")}}
                </div>

            </div>
        </div>
        
    </div>
</template>
<script>
    import {
        COMPONENT_NAME,
           DATE_TIME_FORMAT
    } from "../../util/constants";
    import Logger from "../../services/logger";
    import {
        LOG_TYPE,
        FILE_NAME,
        HTTP_CODES,
        API_VALUES
    } from "../../config/API_DATA";
    import { mapGetters, mapActions } from "vuex";
    import BaseConfiguration from "../../config/base.js";

    export default {
        name: COMPONENT_NAME.C_SUGGFLIGHTRESULTCARD,
        props: {
            suggFlightLs: {
                type: Object | Array
            },

        },
        data: () => ({

            isStopsForNonMyanmar: BaseConfiguration.isStopsForNonMyanmar,
            defaultALImg: BaseConfiguration.defaultALImg,

        }),
         computed: {
              DATE_TIME_FORMAT()
          {
            return DATE_TIME_FORMAT
          },
        ...mapGetters("sResult", {
      GET_AIRLINES: 'GET_AIRLINES',
     
    }),
         },
        methods: {

            ///to get date object in particular format

            dateFormatInTooltip(pDate) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("formatDate");
                    if (pDate != null) {
                        retValue = this.$options.filters.formatDate(
                            pDate,
                           
                            DATE_TIME_FORMAT.DAY_DATE_MONTH
                        );
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_FLIGHTRESULTTEMPLATE,
                        "error in dateFormatInTooltip",
                        err.toString(),
                        "dateFormatInTooltip",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },


            ///to get no of days tooltip
            noOfDaysTooltip(pNoofDays) {
                let retValue;
                try {
                    if (BaseConfiguration.isDebug) console.log("noOfDaysTooltip");
                    if (pNoofDays) {
                        if (pNoofDays == 1) {
                            retValue = this.$t("flightResults.cMLFlightResCard.noOfDaysTooltip1");
                        } else {
                            pNoofDays = pNoofDays.replace("+", "");
                            retValue = this.$t('flightResults.cMLFlightResCard.noOfDaysTooltip2')+' '+ pNoofDays +' '+ this.$t('flightResults.cMLFlightResCard.days');
                        }
                    }
                } catch (err) {
                    let body = Logger.buildRequest(
                        FILE_NAME.C_FLIGHTRESULTTEMPLATE,
                        "error in noOfDaysTooltip",
                        err.toString(),
                        "noOfDaysTooltip",
                        LOG_TYPE.ERROR
                    );
                    Logger.getResponse(body);
                }
                return retValue;
            },

        }
    }
</script>
